import { render, staticRenderFns } from "./EmpresaParceiraFormulario.vue?vue&type=template&id=60115012"
import script from "./EmpresaParceiraFormulario.vue?vue&type=script&lang=js"
export * from "./EmpresaParceiraFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports